var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 12", fill: "none" }, props),
    React.createElement("path", { d: "M8.388.186a.875.875 0 0 1 1.228.15l4.378 5.596-4.462 5.495a.875.875 0 0 1-1.358-1.104l2.864-3.527H.875a.875.875 0 1 1 0-1.75h10.204L8.237 1.414a.876.876 0 0 1 .15-1.228z", fill: "#9C9C9C" })
  );
});